import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { PermisisonAddSchema } from "../../../ValidationSchema";
import ReactSelect from "../../../Components/PortalSelect";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    border: "1px solid #bfc9d4",
    boxShadow: "#000 !important",
    borderRadius: "6px",
    padding: "4px",
    "&:hover": {
      border: "1px solid #bfc9d4",
    },
  }),
  multiValue: (styles) => {
    return {
      ...styles,
      backgroundColor: "#606060",
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: "#000",
    "& > svg": {
      backgroundColor: "#fff",
      borderRadius: "10px",
      marginLeft: "2px",
      marginRight: "2px",
    },
    ":hover": {
      backgroundColor: data.color,
      color: data.color,
    },
  }),
  option: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: "white",
      color: "#000",
      ":hover": {
        backgroundColor: "#f5f5f5",
      },
    };
  },
};

const RolePermissionAdd = () => {
  const Navigate = useNavigate();
  const [userRole, setUserRole] = useState([]);
  const [userPermission, setUserPermission] = useState([]);

  const RoleData = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/admin/roles/get`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setUserRole(res?.data?.data?.docs);
      })
      .catch((err) => {
        if (err.response.data.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const PermissionData = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/admin/permission/get`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setUserPermission(res?.data?.data?.docs);
      })
      .catch((err) => {
        if (err.response.data.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  useEffect(() => {
    RoleData();
    PermissionData();
  }, []);

  const [initialValues] = useState({
    role_id: "",
    permission_name: "",
    permission_id: "",
  });

  const AddRole = useFormik({
    initialValues,
    validationSchema: PermisisonAddSchema,

    onSubmit: (values, action) => {
      axios
        .post(
          `${process.env.REACT_APP_URL}/admin/role-permission/store`,
          values,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            toast.success(`${res?.data?.message}`);
            Navigate("/admin/role-permission", { state: res.data.msg });
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  //   const UserRole = () => {
  //     axios
  //       .get(`${process.env.REACT_APP_URL}/common/roles`)
  //       .then((res) => {
  //         setUserRole(res.data.roles);
  //       })
  //       .catch((err) => {
  //         if (err.response.data.message === "Unauthorized!") {
  //           Navigate("/admin/login");
  //         }
  //       });
  //   };

  useEffect(() => {
    // UserRole();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Add Role Permission</h1>
          <p className="al-sub">Map a permission to a role.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={AddRole.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg></div>
            <h3 className="al-cardhead__title">Role Permission Details</h3>
          </div>
          <div className="al-form">
            <div className="al-form__full">
              <label className="al-label">Permission Name</label>
              <input className="al-input" type="text" placeholder="Enter Permission Name"
                value={AddRole.values.permission_name} onChange={AddRole.handleChange} onBlur={AddRole.handleBlur} name="permission_name" />
              {AddRole.errors.permission_name && AddRole.touched.permission_name ? (
                <div className="al-err">{AddRole.errors.permission_name}</div>
              ) : null}
            </div>

            <div>
              <label className="al-label">Role</label>
              <ReactSelect
                options={userRole.map((item) => ({ id: item.id, label: item.name, value: item.id }))}
                isClearable={false}
                styles={colourStyles}
                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                placeholder="Select Role"
                name="role_id"
                onChange={(e) => AddRole.setFieldValue("role_id", e?.value)}
              />
              {AddRole.errors.role_id && AddRole.touched.role_id && (
                <div className="al-err">{AddRole.errors.role_id}</div>
              )}
            </div>

            <div>
              <label className="al-label">Permission</label>
              <ReactSelect
                options={userPermission.map((item) => ({ id: item.id, label: item.permission_name, value: item.id }))}
                isClearable={false}
                styles={colourStyles}
                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                placeholder="Select Permission"
                name="permission_id"
                onChange={(e) => AddRole.setFieldValue("permission_id", e?.value)}
              />
              {AddRole.errors.permission_id && AddRole.touched.role_id && (
                <div className="al-err">{AddRole.errors.permission_id}</div>
              )}
            </div>
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Create Mapping
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default RolePermissionAdd;
